import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u7E41\u9AD4\u4E2D\u6587",
  code: "zh-TW",
  messages: {
    alert: {
      close: "\u95DC\u9589"
    },
    authForm: {
      hidePassword: "\u96B1\u85CF\u5BC6\u78BC",
      showPassword: "\u986F\u793A\u5BC6\u78BC",
      submit: "\u7E7C\u7E8C"
    },
    banner: {
      close: "\u95DC\u9589"
    },
    calendar: {
      nextMonth: "\u4E0B\u500B\u6708",
      nextYear: "\u660E\u5E74",
      prevMonth: "\u4E0A\u500B\u6708",
      prevYear: "\u53BB\u5E74"
    },
    carousel: {
      dots: "\u9078\u64C7\u8981\u986F\u793A\u7684\u6295\u5F71\u7247",
      goto: "\u8DF3\u8F49\u5230\u7B2C {slide} \u9801",
      next: "\u4E0B\u4E00\u9801",
      prev: "\u4E0A\u4E00\u9801"
    },
    chatPrompt: {
      placeholder: "\u5728\u9019\u88E1\u8F38\u5165\u4F60\u7684\u6D88\u606F..."
    },
    chatPromptSubmit: {
      label: "\u767C\u9001"
    },
    colorMode: {
      dark: "\u6DF1\u8272",
      light: "\u6DFA\u8272",
      switchToDark: "\u5207\u63DB\u5230\u6DF1\u8272\u6A21\u5F0F",
      switchToLight: "\u5207\u63DB\u5230\u6DFA\u8272\u6A21\u5F0F",
      system: "\u7CFB\u7D71"
    },
    commandPalette: {
      back: "\u8FD4\u56DE",
      close: "\u95DC\u9589",
      noData: "\u6C92\u6709\u8CC7\u6599",
      noMatch: "\u6C92\u6709\u76F8\u7B26\u7684\u8CC7\u6599",
      placeholder: "\u8F38\u5165\u547D\u4EE4\u6216\u641C\u5C0B..."
    },
    contentSearch: {
      links: "\u9023\u7D50",
      theme: "\u4E3B\u984C"
    },
    contentSearchButton: {
      label: "\u641C\u5C0B..."
    },
    contentToc: {
      title: "\u672C\u9801\u5167\u5BB9"
    },
    dashboardSearch: {
      theme: "\u4E3B\u984C"
    },
    dashboardSearchButton: {
      label: "\u641C\u5C0B..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u6536\u8D77\u5074\u908A\u6B04",
      expand: "\u5C55\u958B\u5074\u908A\u6B04"
    },
    dashboardSidebarToggle: {
      close: "\u95DC\u9589\u5074\u908A\u6B04",
      open: "\u958B\u555F\u5074\u908A\u6B04"
    },
    error: {
      clear: "\u8FD4\u56DE\u9996\u9801"
    },
    fileUpload: {
      removeFile: "\u79FB\u9664 {filename}"
    },
    header: {
      close: "\u95DC\u9589\u9078\u55AE",
      open: "\u958B\u555F\u9078\u55AE"
    },
    inputMenu: {
      create: "\u5EFA\u7ACB\u300C{label}\u300D",
      noData: "\u6C92\u6709\u8CC7\u6599",
      noMatch: "\u6C92\u6709\u76F8\u7B26\u7684\u8CC7\u6599"
    },
    inputNumber: {
      decrement: "\u6E1B\u5C11",
      increment: "\u589E\u52A0"
    },
    modal: {
      close: "\u95DC\u9589"
    },
    pricingTable: {
      caption: "\u50F9\u683C\u8A08\u756B\u6BD4\u8F03"
    },
    prose: {
      codeCollapse: {
        closeText: "\u6536\u8D77",
        name: "\u7A0B\u5F0F\u78BC",
        openText: "\u5C55\u958B"
      },
      collapsible: {
        closeText: "\u96B1\u85CF",
        name: "\u5C6C\u6027",
        openText: "\u986F\u793A"
      },
      pre: {
        copy: "\u8907\u88FD\u7A0B\u5F0F\u78BC\u5230\u526A\u8CBC\u7C3F"
      }
    },
    selectMenu: {
      create: "\u5EFA\u7ACB\u300C{label}\u300D",
      noData: "\u6C92\u6709\u8CC7\u6599",
      noMatch: "\u6C92\u6709\u76F8\u7B26\u7684\u8CC7\u6599",
      search: "\u641C\u5C0B..."
    },
    slideover: {
      close: "\u95DC\u9589"
    },
    table: {
      noData: "\u6C92\u6709\u8CC7\u6599"
    },
    toast: {
      close: "\u95DC\u9589"
    }
  }
});
